import MeetingAlert from "./MeetingAlert";

export default MeetingAlert;


// WEBPACK FOOTER //
// /src/components/meetingAlert/index.js